import $ from 'jquery';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import Swiper from 'swiper';
import { Breakpoint } from '../../../types/breakpoint';
export default class Structure {
    static $slider = $('.js__structure-slider');
    static swiper;
    static $mainImage = $('.js__structure-main-image');
    static $partImages = $('.js__structure-part-image');
    static options = {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            [Breakpoint.md]: {
                allowTouchMove: false,
            },
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        this.$partImages.css('opacity', 0);
        this.initButtons();
        SwiperCore.use([Navigation, Pagination]);
        this.swiper = new Swiper(this.$slider.get(0), this.options);
        this.handleInitialSliderState();
        this.swiper.on('resize', () => {
            this.handleInitialSliderState();
        });
        this.swiper.on('slideChange', () => {
            this.handleSlideChange();
        });
    }
    static initButtons() {
        $('.js__structure-button')
            .on('show.bs.popover', event => {
            $(event.currentTarget).siblings().popover('hide');
            this.handleButtonStateChange($(event.currentTarget), true);
        })
            .on('shown.bs.popover', () => {
            $(window).on('click', this.hidePopover);
        })
            .on('hide.bs.popover', event => {
            this.handleButtonStateChange($(event.currentTarget), false);
        })
            .on('mousedown', event => {
            this.toggleButtonFocus($(event.currentTarget));
        })
            .on('click', event => {
            event.stopPropagation();
        });
        $('body').on('click', '.popover', event => {
            event.stopPropagation();
        });
        $(window).on('scroll', () => {
            $('.popover').popover('hide');
        });
    }
    static hidePopover() {
        $('.popover').popover('hide');
        $(window).off('click', this.hidePopover);
    }
    static handleButtonStateChange($element, isActive) {
        this.$mainImage.css('opacity', isActive ? 0.5 : 1);
        $($element.data('target')).css('opacity', isActive ? 1 : 0);
        $element.find('.icon').css('transform', `rotate(${isActive ? '45deg' : '0'})`);
    }
    static toggleButtonFocus($element) {
        if ($element.is(':focus')) {
            // Waits for focus event to be triggered and blurs element after
            setTimeout(() => {
                $element.trigger('blur');
            });
        }
    }
    static handleInitialSliderState() {
        this.$mainImage.css('opacity', this.swiper.allowTouchMove ? 0.5 : 1);
        this.$partImages.css('opacity', 0);
        if (this.swiper.allowTouchMove) {
            const $activeSlide = $(this.swiper.slides[this.swiper.activeIndex]);
            $($activeSlide.data('target')).css('opacity', 1);
        }
    }
    static handleSlideChange() {
        const $activeSlide = $(this.swiper.slides[this.swiper.activeIndex]);
        const $previousSlide = $(this.swiper.slides[this.swiper.previousIndex]);
        $($previousSlide.data('target')).css('opacity', 0);
        $($activeSlide.data('target')).css('opacity', 1);
    }
}
